import React from "react";
import {SummaryBlock} from "../SummaryBlock";
import {AcceptBlock} from "../AcceptBlock";
import {REMOVE_ALL_COUPON_EVENTS} from "../../../../store/spirs/actions";
import {useDispatch} from "react-redux";
import CouponBottomMessages from "./CouponBottomMessages";

interface BottomBlockProps {
    showIt: boolean,
    emptyMessage: string
}

export function BottomBlock(props: BottomBlockProps) {
    const dispatch = useDispatch();
    return (props.showIt ? (
        <>
            <SummaryBlock/>
            <CouponBottomMessages/>
            <AcceptBlock removeAllItems={() => dispatch(REMOVE_ALL_COUPON_EVENTS())}/>
        </>
    ) : (
        <h3 className="text-center my-[64px]">{props.emptyMessage}</h3>
    ));
}
